<ng-container *ngIf="opened">
  <kendo-dialog [title]="titleLabel | localizeLabel" (close)="close()" [width]="width">
    <div [ngClass]="{ 'important-warning': hasWarning }"></div>
    <div
      class="bo-info-text vo-link-inside"
      [ngClass]="{ 'vo-info-box--danger': isVoWarningDialog }"
      [innerHtml]="confirmationLabel | localizeLabel"
    ></div>

    <kendo-dialog-actions class="modal-buttons">
      <div
        class="mb-15 mb-md-0"
        [ngClass]="{ 'left-column': !isCancelButtonRightSide, 'right-column': isCancelButtonRightSide }"
      >
        <a
          *ngIf="hasCancelButton"
          (click)="close()"
          [innerHtml]="referenceDataLabels.CancelId | localizeLabel"
          class="link vo-secondary-button-1"
        ></a>
      </div>
      <div *ngIf="confirmationButtonLabel" class="right-column">
        <button
          (click)="confirm()"
          [innerHtml]="confirmationButtonLabel | localizeLabel"
          class="primary-button"
          [ngClass]="{
            'vo-warning-button-1': isVoWarningDialog,
            important: hasWarning,
            'vo-primary-button-1 vo-button--small-padding flex-shrink-0': !isVoWarningDialog
          }"
        ></button>
      </div>
    </kendo-dialog-actions>
  </kendo-dialog>
</ng-container>
